import { parseQuery } from '@calendly/http-tools'

const splitCombinedName = (combined) => {
  if (!combined) return { first: undefined, last: undefined }
  // Split on whitespace or literal '+' (e.g. name=first%2Blast in query strings).
  const parts = combined.trim().split(/[\s+]+/).filter(Boolean)
  if (!parts.length) return { first: undefined, last: undefined }
  return { first: parts[0], last: parts.slice(1).join(' ') }
}

export const buildNewInvitee = () => {
  const query = parseQuery(window.location.search)
  const fullName = query.full_name || query.name
  let firstNameFromFullName
  let lastNameFromFullName
  if (fullName) {
    const { first, last } = splitCombinedName(fullName)
    firstNameFromFullName = first
    lastNameFromFullName = last
  }

  const firstName = query.first_name || firstNameFromFullName
  const lastName = query.last_name || lastNameFromFullName

  return {
    full_name: fullName,
    first_name: firstName,
    last_name: lastName,
    email: query.email
  }
}
